"use strict";

angular.module('app.stickyHeightDirective', [])
  .directive('stickyHeight', function () {
    return {
      restrict: 'AE',
      link: function link(scope, element) {
        scope.$watch(function () {
          element.css('min-height', Math.max(25, element.height()));
        });
      }
    };
  });


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/stickyHeightDirective.js